window.addEventListener("load", function () {
  document.getElementById("copyright-date").innerHTML =
    new Date().getFullYear();
});
